// Shared date helpers for the online-lectures views (schedule, journey, booking).

export const MONTHS = ["led", "úno", "bře", "dub", "kvě", "čen", "čec", "srp", "zář", "říj", "lis", "pro"];
// Indexed by JS getDay() — 0 = Sunday.
export const WEEKDAYS_SHORT = ["ne", "po", "út", "st", "čt", "pá", "so"];

export const time = (s: string) => {
    const d = new Date(s);
    return d.getHours().toString().padStart(2, "0") + ":" + d.getMinutes().toString().padStart(2, "0");
};

export type DayGroup<T> = { day: number; month: string; weekday: string; items: T[] };

export function groupByDay<T extends { start: string }>(items: T[]): DayGroup<T>[] {
    const map = new Map<string, DayGroup<T>>();
    for (const it of items) {
        const d = new Date(it.start);
        const key = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();
        if (!map.has(key)) map.set(key, { day: d.getDate(), month: MONTHS[d.getMonth()], weekday: WEEKDAYS_SHORT[d.getDay()], items: [] });
        map.get(key)!.items.push(it);
    }
    return Array.from(map.values());
}
